import { cx } from '../../lib/cx';

import styles from './Spinner.module.css';

export interface SpinnerProps {
  /** What is being waited for. Shown, and read out. */
  label: string;
  className?: string;
}

/** Something is loading. The words say what; the ring only shows that it is alive. */
export function Spinner({ label, className }: SpinnerProps) {
  return (
    <div role="status" className={cx(styles.spinner, className)}>
      <span aria-hidden className={styles.ring} />
      <span>{label}</span>
    </div>
  );
}
